import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { UserApiService } from 'features/users/api/user-api.service';
import { queryClient } from 'providers';

import { userQueryKeys } from './query-keys';
const { UploadImageProfile } = UserApiService();

export const useChangeImageProfile = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: FormData) => {
      return UploadImageProfile(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: (data: any) => {
        queryClient.invalidateQueries({
          queryKey: userQueryKeys.all,
        });
        if (data?.rs == 1) {
          message.success('Profile Image SuccessFully');
        }
      },
    },
  );
};
